let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8vQPi")).then(() => parcelRequire('B2dH6'));